export default __webpack_public_path__ + "static/media/Fizz 9781408341001.faaf1c4a.jpg";